import React, {HTMLAttributes, RefAttributes} from "react";
import {IonToggle} from "@ionic/react";
import {JSX} from "react/jsx-runtime";
import IntrinsicAttributes = JSX.IntrinsicAttributes;
import {StyleReactProps} from "@ionic/react/dist/types/components/react-component-lib/interfaces";
import {
    BooleanFormItem,
    IBooleanFormItemProps,
    IFormItemElement,
} from "../model/FormModel";
import ErrorWrapperFE from "../form-element/ErrorWrapperFE";

interface IProps extends IFormItemElement
{
    formItemProps:IBooleanFormItemProps;
    elementProps?: IntrinsicAttributes & React.ComponentProps<typeof IonToggle> & Omit<HTMLAttributes<HTMLIonToggleElement>, "style"> & StyleReactProps & RefAttributes<typeof IonToggle>
}

const ToggleFIE = (props: IProps) =>
{
    let {
        form,
        formItemProps,
        label,
        onItemChange,
        children,
        instructions,
        elementProps
    } = props;

    const formItem = form.requireFormItem(formItemProps, "boolean", true) as BooleanFormItem;

    label = label ?? formItem.name;
    label = label || !formItem.required ? label : " ";

    const onChange = (event:CustomEvent) => {
        if(!formItem.setValue(!!event.detail.checked)){
            return;
        }

        if(onItemChange){
            onItemChange(formItem.itemID);
        } else if(onItemChange !== null){
            form.onFormItemChange(formItem.itemID);
        }
    }
    return <div className={form.isFormItemHidden(formItem) ? "d-none" : ""}>
        <ErrorWrapperFE
            formItem={formItem}
        >


            <fieldset>
                <div className="row">
                    <div className="col-12 mb-4">
                        <IonToggle
                            {...elementProps}
                            data-form-item-id={formItem.itemID}
                            labelPlacement={elementProps?.labelPlacement ?? "stacked"}
                            alignment={elementProps?.alignment ?? "start"}
                            name={formItem.itemID}
                            onIonChange={onChange}
                            checked={formItem.getCastValue()}
                        >
                            {!!label &&
                                <legend
                                    className={"form-item-label" + (formItem.required ? " required" : "")}
                                >
                                    {label}
                                    <input id={formItem.itemID} className="d-none" />
                                </legend>
                            }
                            {!!children &&
                                <span>
                                {children}
                            </span>
                            }
                        </IonToggle>
                    </div>
                    {!!instructions && (
                        <div className="col-12">
                            <span className="instructions">{instructions}</span>
                        </div>
                    )}
                </div>
            </fieldset>
        </ErrorWrapperFE>
    </div>;
}

export default ToggleFIE;